import type {
  CreateDeploymentAutomatorV2MutationRequestApi,
  DeploymentAutomatorResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type {
  ProfileGroupBody,
  SimpleCreateDeploymentAutomatorResponse,
} from '../../../models/deployment/createDeploymentAutomator.model';

export function mapProfileGroupBodyToCreateDeploymentAutomatorV2MutationRequestApi({
  name,
  configurationId,
  description,
  dynamicGroupReferenceId,
  status,
  triggerTypeAutomator,
  triggerTypeDeployment,
}: ProfileGroupBody): CreateDeploymentAutomatorV2MutationRequestApi {
  return {
    name,
    description,
    deploymentRequestOptions: {
      configurationReference: {
        id: configurationId,
      },
    },
    dynamicGroupReference: {
      id: dynamicGroupReferenceId,
    },
    status,
    triggers: [
      {
        type: triggerTypeAutomator,
        deploymentRequestTrigger: {
          type: triggerTypeDeployment,
        },
      },
    ],
  };
}

export function mapCreateDeploymentAutomatorResponse({
  id,
  name,
  status,
}: DeploymentAutomatorResourceReadV2Api): SimpleCreateDeploymentAutomatorResponse {
  return { id, name, status };
}
